import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=06a9cb60&scoped=true"
import script from "./ToDoList.vue?vue&type=script&lang=js"
export * from "./ToDoList.vue?vue&type=script&lang=js"
import style0 from "./ToDoList.vue?vue&type=style&index=0&id=06a9cb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a9cb60",
  null
  
)

export default component.exports